import { t } from "@lingui/macro";
import { Plus } from "@phosphor-icons/react";
import { KeyboardShortcut } from "@reactive-resume/ui";
import { useNavigate } from "react-router-dom";
import { ResumeDto } from "@reactive-resume/dto";
import { useDialog } from "@/client/stores/dialog";

import { BaseListItem } from "./base-item";

type Props = {
  mode?: "builder" | "legacy";
};

export const CreateResumeListItem = ({ mode = "legacy" }: Props) => {
  const navigate = useNavigate();
  const { open } = useDialog<ResumeDto>("resume");

  return (
    <BaseListItem
      start={<Plus size={18} />}
      title={
        <>
          <span>{t`Create a new resume`}</span>
          {/* eslint-disable-next-line lingui/no-unlocalized-strings */}
          <KeyboardShortcut className="ml-2">^N</KeyboardShortcut>
        </>
      }
      description={t`Start building from scratch`}
      onClick={() => {
        if (mode === "builder") navigate("/resume-builder/create");
        else open("create");
      }}
    />
  );
};
